import { confirmOrder, getInterestsInfo,unavailableQuery, POST_getPreciseDeliveryDate} from '@fetch/order';
import { fetchGoodsTags } from '@fetch';
import { arrayUnique } from '@utils/array';
// import { Message } from 'element-ui';
import { getQueryString, getHourTime, getDateStr, getTimestamp } from '@utils';
import { HAOTAO_FLAG, PRODUCT_ACCESSORY_CHANNEL, UNION_NAME } from '@utils/config';
import { sha } from '@/utils/SHA';
import { getBirthdayInfoList, getPartsNum } from '@/utils/special';

const state = {
  buyGoodsList: [],
  freightInfoList: [],
  annexItemStock: 'N',
  userAddressList: [],
  notSaleGoodsList: [],
  createOrderParameter: {}, // 属性 addressid 与 cookie 存储的当前 地址信息保持一致
  addressId: 0,
  settleAccountInfo: {
    oldTotalFreight: 0,
    orignOrderTotalFeight: '0.00', // 原始未膨胀运费，需要作为入参传给后端
    orderTotalFeight: '0.00',
    orderTotalGoodsAmount: '0.00',
    orderAccountPayable: '0.00',
    additionalDiscountAmount:0,//专项优惠
  },
  energizerFreightInfo: {},
  epidemicDeliverInfo: {
    allowDelivery: null,
    mandatoryType: null,
    promptWords: null,
  },
  hasHaitao: false,
  identityCardName: '',
  identityCardNo: '',
  lock: true,
  isCreateOrder: true,
  couponInfo: {
    availableCouponList: [],
    unusableCouponList: [],
    coupon: '',
    couponNum: 0,
  }, // 优惠券信息
  confirmOrderTimestamp: '',
  oldTimestamp: '',
  interestsInfo: {},
  fppConfigure: {},
};

const getters = {
  getUserAddressList: state => state.userAddressList,
  getBuyGoodsList: state => state.buyGoodsList,
  getFreightInfoList: state => state.freightInfoList,
  getAnnexItemStock: state => state.annexItemStock,
  getNotSaleGoodsList: state => state.notSaleGoodsList,
  getEpidemicDeliverInfo: state => state.epidemicDeliverInfo,
  getCouponInfo: state => state.couponInfo,
  getOldTimestamp: state => state.oldTimestamp,
  getConfirmOrderTimestamp: state => state.confirmOrderTimestamp,
  getInterestInfo:state=> state.interestsInfo,
  getSettleAccountInfo: (state, getters) => {
    const products = getters.getBuyGoodsList;
    const userAddressList = getters.getUserAddressList;
    const address = userAddressList.filter(item => item.id === state.addressId)[0];
    const orderTotalNums = products.length
      ? products
        .map(item => item.totalNum)
        .reduce((accumulator, current) => accumulator + current) + getPartsNum(products)
      : 0; // 默认值 0 所有商户总数

    return {
      addressInfo: !address
        ? ''
        : address.provinceName +
        address.cityName +
        address.regionName +
        address.address,
      consigneeInfo: !address ? window.TLang('请添加或选择用户收货地址', 'common') : address.consignee + address.mobile,
      orderTotalNums,
      ...state.settleAccountInfo,
    };
  },
  getEnergizerFreightInfo: state => state.energizerFreightInfo,
  getFppConfigure: state=> state.fppConfigure,
};

const actions = {
  getConfirmOrder({ commit }, data) {
    commit('setAddressID', data); // cookie 中地址id,与该 id 一致
    return confirmOrder(data).then(async res => {
      if (res && res.code) return;
      let goodsList = [];
      // 设置福拼拼相关字段
      const config = {
        groupItem: res.groupItem,
        groupItemClassStyle: res.groupItemClassStyle,
        groupItemShowRmbSymbol: res.groupItemShowRmbSymbol,
        priceLimitAmount: res.priceLimitAmount,
      };
      commit('setFppConfigure',config);
      if (res.buyGoodsList && res.buyGoodsList.length > 0) {
        let arrList = []

        res.buyGoodsList.forEach(item => {
          item.warehouseList.forEach(ware => {

            if (ware.deliveryInfo && ware.deliveryInfo.deliveryWay == '1') {
              arrList.push({
                merchantNo: item.merchantNo,
                warehouseNo: ware.warehouseNo,
              });
            }
   
            ware.goodsList.forEach(goods => {
              if (goods.goodsId && goods.categoryId) {
                goodsList.push({ goodsId: goods.goodsId, categoryId: goods.categoryId });
              }
            });
          });
        });

        if (arrList.length > 0) {
          // 限制精准配送的限制日期
          const {data: additionalProperties1} = await POST_getPreciseDeliveryDate({
            deliveryInfo: arrList,
            day: getDateStr(),
          });

          res.dates = additionalProperties1;
        }


        try {
          await fetchGoodsTags({ goodsList, channel: 2,returnLimit:true }).then(tagRes => {
            if (tagRes && tagRes.length > 0) {
              res.buyGoodsList.forEach(item => {
                item.warehouseList.forEach(ware => {
                  ware.goodsList.forEach(goods => {
                    const goodTag = tagRes.find(tag => tag.categoryId == goods.categoryId && tag.goodsId == goods.goodsId) || {};
                    let tags = goodTag && goodTag.tags ? goodTag.tags : [];
                    // 爆炸贴数据
                    let stickerImgList = tags.filter(item => item.type === 2);
                    goods.stickerImgList = stickerImgList;
                    goods.tags = tags;
                    goods.discountInfo = {
                      totalLimit:goodTag.totalLimit,
                      saleNum:goodTag.saleNum,
                      discount:goodTag.discount,
                      discountPrice:goodTag.discountPrice,
                      discountTagShow:goodTag.discountTagShow,
                      mktTagShow:goodTag.mktTagShow,
                    };
                  });
                });
              });
              commit('setBuyGoodsList', res);
              commit('setFreightInfoList', res);
              commit('setEnergizerFreightInfo', {...res});
              commit('setAnnexItemStock', res);
              commit('setNotSaleGoodsList', res);
              commit('setUserAddressList', { ...res, ...data }); // 取 checkedAddressId
              commit('setSettleAccountInfo', res);
              commit('setCreateOrderParameter', res);
              commit('setEpidemicDeliverInfo', res);
              commit('setCouponInfo', res);
              commit('setTimeStamp', res);
            } else {
              commit('setBuyGoodsList', res);
              commit('setFreightInfoList', res);
              commit('setEnergizerFreightInfo', {...res});
              commit('setAnnexItemStock', res);
              commit('setNotSaleGoodsList', res);
              commit('setUserAddressList', { ...res, ...data }); // 取 checkedAddressId
              commit('setSettleAccountInfo', res);
              commit('setCreateOrderParameter', res);
              commit('setEpidemicDeliverInfo', res);
              commit('setCouponInfo', res);
              commit('setTimeStamp', res);
            }
          });
        } catch (error) {
          console.log('订单确认页tags接口', error);
          commit('setBuyGoodsList', res);
          commit('setFreightInfoList', res);
          commit('setEnergizerFreightInfo', {...res});
          commit('setAnnexItemStock', res);
          commit('setNotSaleGoodsList', res);
          commit('setUserAddressList', { ...res, ...data }); // 取 checkedAddressId
          commit('setSettleAccountInfo', res);
          commit('setCreateOrderParameter', res);
          commit('setEpidemicDeliverInfo', res);
          commit('setCouponInfo', res);
          commit('setTimeStamp', res);
        }
        
      } else {
        commit('setBuyGoodsList', res);
        commit('setFreightInfoList', res);
        commit('setEnergizerFreightInfo', {...res});
        commit('setAnnexItemStock', res);
        commit('setNotSaleGoodsList', res);
        commit('setUserAddressList', { ...res, ...data }); // 取 checkedAddressId
        commit('setSettleAccountInfo', res);
        commit('setCreateOrderParameter', res);
        commit('setEpidemicDeliverInfo', res);
        commit('setCouponInfo', res);
        commit('setTimeStamp', res);
      }
      try{
        await getInterestsInfo({oldTimestamp:res.oldTimestamp,timestamp:res.confirmOrderTimestamp}).then(intRes=>{
          if (intRes && intRes.data && intRes.data.sequenceNo){
            const secretKey = 'TQaXTvES' ;
            let params = {
              appId: '100005',
              msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
              timestamp: +new Date(),
              version: '1.0.1',
              body: JSON.stringify({
                key:intRes.data.sequenceNo,
              }),
              sign: '',
            };
            params.sign = sha(secretKey + params.body + secretKey);
            unavailableQuery(params).then(res=>{
              if(res && res.data){
                intRes.data.cardInfo.unavailableCardList = res.data.unavailableCardList || [];
              }
            });
          }
          commit('setInterestsInfo',intRes && intRes.data?intRes.data:null);
        });

      } catch(error){
        console.log('福利卡、余额、积分信息');
      }
    });
  },
  onChangeDeliveryWay({ commit }, deliveryInfoItem) {
    // console.log('333', deliveryInfoItem);
    commit('setBuyInfoList', deliveryInfoItem);
  },
  onSetUserRemark({ commit }, userRemark) {
    commit('setUserRemark', userRemark);
  },
  onHaitao({ commit }, identityInfo) {
    commit('setHaiTao', identityInfo);
  },
  onSetInterestsInfo({ commit },interInfo) {
    commit('setInterestsInfo',interInfo);
  },
  getInterestsInfoFn({ commit }, data) {
    getInterestsInfo(data).then(intRes=>{
      if(intRes && intRes.data){
        if (intRes && intRes.data && intRes.data.sequenceNo){
          const secretKey = 'TQaXTvES' ;
          let params = {
            appId: '100005',
            msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
            timestamp: +new Date(),
            version: '1.0.1',
            body: JSON.stringify({
              key:intRes.data.sequenceNo,
            }),
            sign: '',
          };
          params.sign = sha(secretKey + params.body + secretKey);
          unavailableQuery(params).then(res=>{
            if(res && res.data){
              intRes.data.cardInfo.unavailableCardList = res.data.unavailableCardList || [];
            }
          });
        }
        commit('setInterestsInfo',intRes.data);
      }
    });
  },
  // createOrder({ commit, state }) {
  //   createOrder(state.createOrderParameter).then((res) => {
  //     if (res.code) {
  //       Message({
  //         message: `${res.msg}`,
  //         type: 'error',
  //       });
  //       commit('setLock', true);
  //       return;
  //     }

  //     setTimeout(()=>{
  //       commit('setLock', true);
  //     }, 500)
  //     window.location.href = res;
  //   });
  // },
};

const mutations = {
  setLock(state, flag) {
    state.lock = flag;
  },
  // 重装 所有仓库的可售商品进入 merchantItem.productsList
  setBuyGoodsList(state, { buyGoodsList, dates }) {
    if (!buyGoodsList) buyGoodsList = [];
    const { union_scale, union_name = UNION_NAME } = window;
    buyGoodsList.map(merchantItem => {
      merchantItem.totalNum = 0;
      merchantItem.merchantTotalPrice = (
        merchantItem.totalFreight + merchantItem.totalGoodsAmount
      ).toFixed(2); // 商户需付款总金额，保留两位小数 （后端吐到前端的值中，空值为 null）

      merchantItem.warehouseList &&
        merchantItem.warehouseList.map(warehouseItem => {
          // 重置配送方式开始
          warehouseItem.deliveryInfo = warehouseItem.deliveryInfo || {}; //避免 null 值报错
          if (warehouseItem.deliveryInfo.deliveryWay !== '2') {
            if (warehouseItem.deliveryInfo.deliveryWay === '1') {
              const preciseDeliveryConfig = !warehouseItem.deliveryInfo
                .preciseDeliveryConfig
                ? []
                : arrayUnique(warehouseItem.deliveryInfo.preciseDeliveryConfig); //配送方式去重

              // 配送，配送时段
              warehouseItem.deliveryInfo.preciseDeliveryOptions = preciseDeliveryConfig.map(
                item => {
                  return {
                    label: item,
                    value: item,
                    disabled: false,
                  };
                },
              );
            }
            // 精准配送，配送时段日期选择
            let pickerTimestampStart =
              new Date().getTime() + (warehouseItem.deliveryInfo.preciseDeliveryDay - 1) * 24 * 60 * 60 * 1000; // 时间戳

            let maxPreciseDeliveryDay =
              warehouseItem.deliveryInfo.maxPreciseDeliveryDay > 0 ? (warehouseItem.deliveryInfo.maxPreciseDeliveryDay - 1) : 0;
            let pickerTimestampEnd =
              new Date(
                warehouseItem.deliveryInfo.defaultPreciseDefaultDay,
              ).getTime() +
              maxPreciseDeliveryDay * 24 * 60 * 60 * 1000; // 时间戳

            if (warehouseItem.deliveryInfo.deliveryWay === '1'
              && (warehouseItem.deliveryInfo.preciseDeliveryDay === 0 || warehouseItem.deliveryInfo.preciseDeliveryDay === '0')
              && new Date().getTime() + 3 * 60 * 60 * 1000 >= getHourTime(warehouseItem.deliveryInfo.defaultPreciseDefaultDay, warehouseItem.deliveryInfo.preciseDeliveryConfig[warehouseItem.deliveryInfo.preciseDeliveryConfig.length - 1])
            ) {
              // 精准配送   当天配送   当前时间+3小时大于最后可配送时间, 可配送时间为第二天,当天不可配送
              warehouseItem.deliveryInfo.defaultPreciseDefaultDay = (new Date(new Date(warehouseItem.deliveryInfo.defaultPreciseDefaultDay).getTime() + 24 * 60 * 60 * 1000)).toLocaleDateString().split('/').join('-');
              pickerTimestampStart = new Date().getTime() + (warehouseItem.deliveryInfo.preciseDeliveryDay) * 24 * 60 * 60 * 1000;
            }

            if (warehouseItem.deliveryInfo.deliveryWay === '1') {
              warehouseItem.deliveryInfo.expectDeliveryTime = null;
            }

            let deliveryWay = warehouseItem.deliveryInfo.deliveryWay;
            let isPreSell = warehouseItem.goodsList.findIndex(item => item.preSell) > -1;
            if (deliveryWay === '3') {
              // 新指定日期配送方式 不可切换选择日期
              if (warehouseItem.deliveryStyle == 2 && warehouseItem.deliveryInfo.shipmentTime) {
                pickerTimestampStart = new Date(warehouseItem.deliveryInfo.shipmentTime).getTime()- 8 * 60 * 60 * 1000;
                pickerTimestampEnd = new Date(warehouseItem.deliveryInfo.shipmentTime).getTime();
              } else {
                //TODO:指定日期配送可选日期区间的开始日期（startTime）和结束日期（endTime）取值从接口取
                pickerTimestampStart = new Date(warehouseItem.deliveryInfo.startTime).getTime()- 8 * 60 * 60 * 1000;
                pickerTimestampEnd = new Date(warehouseItem.deliveryInfo.endTime).getTime();
              }
             
              let list = warehouseItem.deliveryInfo.unavailableTime || [];

              if (isPreSell && warehouseItem.deliveryStyle != 2) {
                // 预售不展示默认选中时间
                warehouseItem.deliveryInfo.expectDeliveryTime = '';
              } else {
                let obj;
                let sessionDateList = JSON.parse(window.sessionStorage.getItem('pcDeliverWay3')) || [];
                if(sessionDateList.length > 0){
                  obj = sessionDateList.find(item => item.warehouseId === warehouseItem.warehouseId&&item.userChange === true) || {choosedDate:''};
                }
                // 新指定日期配送方式 不可切换选择日期
                if (warehouseItem.deliveryStyle == 2 && warehouseItem.deliveryInfo.shipmentTime) {
                  warehouseItem.deliveryInfo.expectDeliveryTime = warehouseItem.deliveryInfo.shipmentTime;
                }
                // 默认选中时间 比较缓存日期是否在可选范围日期内
                else if (obj &&
                    obj.choosedDate &&
                    new Date(obj.choosedDate).getTime() >= pickerTimestampStart &&
                    new Date(obj.choosedDate).getTime() <= pickerTimestampEnd &&
                    !list.includes(obj.choosedDate)
                ) {
                  warehouseItem.deliveryInfo.expectDeliveryTime = obj.choosedDate;
                } else {
                  warehouseItem.deliveryInfo.expectDeliveryTime = warehouseItem.deliveryInfo.startTime;
                }
              }

              warehouseItem.deliveryInfo.pickerOptions = {
                disabledDate(time) {
                  let Y = time.getFullYear() + '-';
                  let M = (time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1) + '-';
                  let D = time.getDate() < 10 ? '0' + time.getDate() : time.getDate() + '';
                  let temp = Y + M + D;
                  return (
                    time.getTime() < pickerTimestampStart ||
                    time.getTime() > pickerTimestampEnd ||
                    list.includes(temp)
                  );
                },
              };
            } else if (deliveryWay === '1' && dates) {
              // 精准配送的禁用日期
              const dateKey =  `${merchantItem.merchantNo}:${warehouseItem.warehouseNo}`;
              const { dates: list, defaultDate, type, maxPreciseDeliveryDay: day = 0 } = dates[dateKey] || {};

              const beginDate = defaultDate + 'T00:00';
              const maxPreciseDeliveryDay = Math.max(day - 1, 0);
              warehouseItem.deliveryInfo.pickerOptions = {
                disabledDate(time) {

                  if (type === 1) {
                    pickerTimestampStart = getTimestamp(0, beginDate);
                    pickerTimestampEnd = getTimestamp(maxPreciseDeliveryDay, beginDate);
                    
                    return (
                      time.getTime() < pickerTimestampStart ||
                      time.getTime() > pickerTimestampEnd
                    );
                  } else {
                    let D = time.getDate() < 10 ? '0' + time.getDate() : time.getDate() + '';

                    pickerTimestampStart = getTimestamp(0, beginDate);
                    pickerTimestampEnd = getTimestamp(maxPreciseDeliveryDay, beginDate);

                    return  (
                      time.getTime() < pickerTimestampStart  ||
                      time.getTime() > pickerTimestampEnd ||
                      !list.includes(+D)
                    );
                  }
                },
              };
            } else {
              warehouseItem.deliveryInfo.pickerOptions = {
                disabledDate(time) {
                  return (
                    time.getTime() < pickerTimestampStart ||
                    time.getTime() > pickerTimestampEnd
                  );
                },
              };
            }
          }
          // 重置配送方式结束

          warehouseItem.totalNum = 0; // 仓库数量小计
          warehouseItem.totalPrice = 0; // 仓库商品价格小计
          let birInfoList = [{
            goodsList: [],
            index: 0,
            warehouseId: 0,
            warehouseNo: '',
          }];
          warehouseItem.deliveryInfo.birthdayInfoList = [];
          warehouseItem.goodsList &&
            warehouseItem.goodsList.map(item => {
              if (item.haitaoLogo === HAOTAO_FLAG) state.hasHaitao = true;
              if (item.channel === PRODUCT_ACCESSORY_CHANNEL) warehouseItem.accessoryFlag = true;
              item.price = Number(item.price * union_scale).toFixed(2);
              item.totalPrice = (Number(item.num) * Number(item.price)).toFixed(
                2,
              );
              warehouseItem.totalPrice += Number(item.totalPrice);
              warehouseItem.totalNum += item.num;
              merchantItem.totalNum += item.num;
              
              // 判断商品是否含有生日牌信息
              const sessionBirthdayInfoList = JSON.parse(window.sessionStorage.getItem('birthdayInfoList')) || [];
              if (sessionBirthdayInfoList && sessionBirthdayInfoList.length > 0) {
                sessionBirthdayInfoList.forEach(a => {
                  a.goodsList && a.goodsList.length > 0 && a.goodsList.forEach(b => {
                    if (b.categoryId == item.categoryId && b.goodsId == item.goodsId) {
                      // console.log('item.categoryId, item.goodsId', item.categoryId, item.goodsId);
                      birInfoList[0].index = a.index;
                      birInfoList[0].warehouseId = a.warehouseId;
                      birInfoList[0].warehouseNo = a.warehouseNo;
                      birInfoList[0].goodsList.push({
                        goodsId: item.goodsId,
                        categoryId: item.categoryId,
                        birthdayRemark: b.birthdayRemark,
                      });
                      warehouseItem.deliveryInfo.birthdayInfoList = birInfoList;
                      // console.log('birInfoList', warehouseItem.deliveryInfo.birthdayInfoList);
                    }
                  });
                });
              }
            });
          warehouseItem.totalPrice = Number(warehouseItem.totalPrice).toFixed(2);
        });
    });

    state.buyGoodsList = buyGoodsList;
    state.union_name = union_name || this.TLang('福豆','card');
    state.union_scale = union_scale;
  },

  setFreightInfoList(state, { freightInfoList }) {
    state.freightInfoList = freightInfoList;
  },

  setAnnexItemStock(state, { annexItemStock }) {
    state.annexItemStock = annexItemStock;
  },

  // 重装 确认timeStamp
  setTimeStamp(state,{ confirmOrderTimestamp,oldTimestamp }){
    state.confirmOrderTimestamp = confirmOrderTimestamp || '';
    state.oldTimestamp = oldTimestamp || '';
  },

  // 重装福利卡、积分、余额
  setInterestsInfo(state, res){
    state.interestsInfo = res;
  },

  // 重装福拼拼相关字段
  setFppConfigure(state, res){
    state.fppConfigure = res;
  },

  // 重装 所有不可售商品
  setNotSaleGoodsList(state, { notSaleGoodsList }) {
    state.notSaleGoodsList = notSaleGoodsList || [];
  },
  // 重装订单结算信息
  setSettleAccountInfo(state, { isAllowed, oldTotalFreight, orderTotalFreight, orderTotalGoodsAmount, reducePrice, refundFlag,additionalDiscountAmount }) {
    const { union_scale, union_icon, union_name = UNION_NAME } = window;
    state.settleAccountInfo = {
      isAllowed: isAllowed,
      oldTotalFreight: oldTotalFreight,
      orignOrderTotalFeight: orderTotalFreight,
      orderTotalFeight: Number(orderTotalFreight * union_scale).toFixed(2),
      orderTotalGoodsAmount: Number(orderTotalGoodsAmount * union_scale).toFixed(2),
      fudou: union_icon || require('@/assets/images/fudou.png'),
      union_name: union_name || this.TLang('福豆','card'),
      orderAccountPayable: Number((orderTotalGoodsAmount + orderTotalFreight - (reducePrice ? reducePrice : 0)) * union_scale).toFixed(2),
      reducePrice: reducePrice ? Number(reducePrice).toFixed(2) : 0,
      // TODO: 微创确认订单新增字段是否开启提示：1是要提示  0是不提示
      refundFlag: +refundFlag === 1 ? true : false,
      additionalDiscountAmount: additionalDiscountAmount || 0,
    };
  },

  setEnergizerFreightInfo(state, res) {
    // debugger
    // console.log('返回参数res', res)
    state.energizerFreightInfo = {
      oldTotalFreight: res.oldTotalFreight,
      orderTotalFeight: res.orderTotalFreight,
    };
  },
  // 重装疫情配送信息
  setEpidemicDeliverInfo(state, { allowDelivery, mandatoryType, promptWords }) {
    state.epidemicDeliverInfo = {
      allowDelivery: allowDelivery,
      mandatoryType: mandatoryType,
      promptWords: promptWords,
    };
  },
  // 重装优惠券信息
  setCouponInfo(state, {availableCouponList, unusableCouponList,coupon}) {
    let usableNum = availableCouponList && availableCouponList.length >= 0 ? availableCouponList.length : 0;
    let unsableNum = unusableCouponList && unusableCouponList.length >= 0 ? unusableCouponList.length : 0;
    state.couponInfo = {
      availableCouponList: availableCouponList || [],
      unusableCouponList: unusableCouponList || [],
      coupon: coupon,
      couponNum: usableNum + unsableNum,
    };
  },
  // 重装用户地址列表
  setUserAddressList(state, { userAddressList, addressId }) {
    let item, otherItem;
    // 用户选中地址放置在第一位
    if (!userAddressList) return;
    if (addressId) {
      item = userAddressList.find(item => {
        return item.id == parseInt(addressId);
      });
      otherItem = userAddressList.filter(item => {
        return item.id !== parseInt(addressId);
      });
      item && otherItem.unshift(item);
    } else {
      otherItem = userAddressList;
    }

    state.userAddressList = otherItem.map(item => {
      item.detail =
        item.provinceName +
        item.cityName +
        item.regionName +
        item.streetName +
        item.address;
      return item;
    });
  },
  // 修改配送地址
  setAddressID(state, { addressId }) {
    state.addressId = addressId;
    state.createOrderParameter.addressId = addressId;
  },
  // 修改配送方式
  setBuyInfoList(state, { deliveryInfoItem }) {

    const buyInfoList = state.createOrderParameter.buyInfoList;
    const index = buyInfoList.findIndex(
      item => (
        item.index === deliveryInfoItem.index // 根据运单判断
      ),
    );
    if (deliveryInfoItem.deliveryWay === '3' && !deliveryInfoItem.expectDeliveryTime) {
      state.isCreateOrder = false;
    }
    buyInfoList[index] = deliveryInfoItem;

    state.createOrderParameter.buyInfoList = buyInfoList;
  },
  setHaiTao(state, { identityCardName, identityCardNo }) {
    state.createOrderParameter.identityCardName = identityCardName;
    state.createOrderParameter.identityCardNo = identityCardNo;
  },

  // 初始化提交订单参数
  setCreateOrderParameter(state, { buyGoodsList, confirmOrderTimestamp }) {
    if (!buyGoodsList) buyGoodsList = [];
    const buyInfoList = [];
    const { identityCardName, identityCardNo, createOrderParameter } = state;

    const {buyInfoList: bugInfoListState} = createOrderParameter || {};
    const buyInfo = getBuyInfos(bugInfoListState);
  
    buyGoodsList.map(merchantItem => {
      merchantItem.warehouseList.map(warehouseItem => {
        const bigId = [warehouseItem.merchantId, warehouseItem.warehouseId].join('-');
        const tregetBuyInfo = buyInfo[bigId] || {};

        const parameter =
          warehouseItem.deliveryInfo.deliveryWay === '1' || warehouseItem.deliveryInfo.deliveryWay === '3'
            ? {
              index: warehouseItem.index, // 运单号
              merchantId: merchantItem.merchantId,
              warehouseId: warehouseItem.warehouseId,
              deliveryWay: warehouseItem.deliveryInfo.deliveryWay,
              // expectDeliveryTime: warehouseItem.deliveryInfo.deliveryWay === '3' && warehouseItem.goodsList.findIndex(item => item.preSell) > -1 ? '' : warehouseItem.deliveryInfo.defaultPreciseDefaultDay,
              expectDeliveryTime: warehouseItem.deliveryInfo.deliveryWay === '3' && warehouseItem.goodsList.findIndex(item => item.preSell) > -1 ? '' : (warehouseItem.deliveryStyle == 2 && warehouseItem.deliveryInfo.shipmentTime ? warehouseItem.deliveryInfo.shipmentTime : tregetBuyInfo.expectDeliveryTime || warehouseItem.deliveryInfo.startTime),

              cutOffTimeStr: warehouseItem.deliveryInfo.deliveryWay === '3' ? warehouseItem.deliveryInfo.cutOffTimeStr : '',
              expectPreciseTime: warehouseItem.deliveryInfo.defaultpreciseDefaultTime,
              userRemark: warehouseItem.deliveryInfo.userRemark,
              birthdayInfoList: warehouseItem.deliveryInfo.birthdayInfoList || [],
            }
            : {
              index: warehouseItem.index, // 运单号
              merchantId: warehouseItem.merchantId,
              warehouseId: warehouseItem.warehouseId,
              deliveryWay: warehouseItem.deliveryInfo.deliveryWay,
              expectDeliveryTimeType: warehouseItem.deliveryInfo.defaultOrdinaryDeliver || 0,
              userRemark: warehouseItem.deliveryInfo.userRemark,
              birthdayInfoList: warehouseItem.deliveryInfo.birthdayInfoList || [],
            };
            
        if(warehouseItem.deliveryInfo.deliveryWay === '1'){
          parameter.expectDeliveryTime = tregetBuyInfo.expectDeliveryTime || null;
          parameter.expectPreciseTime = tregetBuyInfo.expectPreciseTime || null;
        }
        console.log(JSON.stringify(parameter, null, 2));
        warehouseItem.deliveryWay = parameter;
        buyInfoList.push(parameter);
      });
    });

    state.createOrderParameter = {
      ...state.createOrderParameter,
      confirmOrderTimestamp,
      buyInfoList,
      platform: 0, //1 TW, 0 PC
      identityCardName,
      identityCardNo,
      cart: Number(getQueryString('orderType')) === 1,
    };
  },
};

function getBuyInfos(list) {
  if (!Array.isArray(list)) return {};

  return list.reduce((memo, info) => {
    const {merchantId, warehouseId} = info;
    const key = [merchantId,warehouseId].join('-');
    memo[key] = info;
    return memo;
  }, {});
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
